import { render, staticRenderFns } from "./courseF.vue?vue&type=template&id=ec323b92&scoped=true&"
import script from "./courseF.vue?vue&type=script&lang=js&"
export * from "./courseF.vue?vue&type=script&lang=js&"
import style0 from "./courseF.vue?vue&type=style&index=0&id=ec323b92&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec323b92",
  null
  
)

export default component.exports